import { render, staticRenderFns } from "./workOrderDetails.vue?vue&type=template&id=67faa3f1&scoped=true&"
import script from "./workOrderDetails.vue?vue&type=script&lang=js&"
export * from "./workOrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./workOrderDetails.vue?vue&type=style&index=0&id=67faa3f1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67faa3f1",
  null
  
)

export default component.exports